/* global FB */

import './style.scss';

import React from 'react';
import Parse from 'parse';
import { connect } from 'react-redux';
import * as loginActions from 'components/login/actions';
import { trackNow } from 'shared/models/analytic';

class FacebookBtn extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  fbLogin() {
    const { fbLoggedIn, onComplete, onLogin, onError, promoCode } = this.props;
    this.setState({ loading: true });
    if (this.props.onLoading) this.props.onLoading();
    const component = this;
    Parse.FacebookUtils.logIn(
      'public_profile,email,user_birthday,user_location',
      {
        success: function(user) {
          if (user.existed()) {
            trackNow('Registration', { accountType: 'Facebook', promoCode });
            return fbLoggedIn(user).then(() => {
              if (onLogin) return onLogin(user);
              return window.location.reload();
            });
          }
          FB.api(
            '/me?fields=first_name,last_name,email,gender,birthday',
            function(response) {
              if (response.error) return console.log(response.error); // eslint-disable-line no-console
              user.set('firstname', response.first_name);
              user.set('lastname', response.last_name);
              user.set('email', response.email);
              user.set('gender', response.gender);
              user.set('birthday', response.birthday);
              user.set('fbID', response.id);
              user.set(
                'fbAvatarURL',
                'https://graph.facebook.com/' +
                  response.id +
                  '/picture?type=square&return_ssl_resources=1'
              );
              user.set('signup_platform', 'web');
              user
                .save()
                .then(user => {
                  trackNow('Login', { accountType: 'Facebook' });
                  fbLoggedIn(user, true).then(() => onComplete(user));
                })
                .catch(error => {
                  console.log(error); // eslint-disable-line no-console
                  trackNow('Registration Failed', {
                    accountType: 'Facebook',
                    reason: error.message
                  });
                });
            }
          );
        },
        error: function(user, error) {
          component.setState({ loading: false });
          console.log(error); // eslint-disable-line no-console
          if (error.code === Parse.Error.INVALID_SESSION_TOKEN) {
            Parse.User.logOut();
            if (onError) {
              onError({ message: 'Login failed. Please try again' });
            }
          } else if (onError) {
            onError(error);
          }
          trackNow('Login Failed', {
            accountType: 'Facebook',
            reason: error.message
          });
        }
      }
    );
  }

  render() {
    const className =
      'fb-button' +
      (this.props.className ? ` ${this.props.className}` : ' button-wide');

    return (
      <button
        className={className}
        onClick={this.fbLogin.bind(this)}
        disabled={this.state.loading}
      >
        <i className="icon-facebook fb-button__icon" />
        <span className="fb-button__text">
          {this.props.text ? this.props.text : 'Sign in with Facebook'}
        </span>
      </button>
    );
  }
}

FacebookBtn.defaultProps = {};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, { ...loginActions })(FacebookBtn);



// WEBPACK FOOTER //
// ./shared/components/facebookBtn/index.js